import styles from './QuestionCard.module.css';
import type { ClarifyingQuestion } from '../types';

interface QuestionCardProps {
  question: ClarifyingQuestion;
  answer: string;
  onChange: (answer: string) => void;
}

export default function QuestionCard({ question, answer, onChange }: QuestionCardProps) {
  return (
    <div className={styles.card} data-testid="bot-question">
      <p className={styles.question}>{question.question}</p>
      <label className={styles.label}>Default answer</label>
      <textarea
        data-testid="default-answer"
        className={styles.input}
        value={answer}
        onChange={(e) => onChange(e.target.value)}
        rows={2}
      />
    </div>
  );
}
